<div class="form-group">
  <small class="text-secondary" *ngIf="(layerDescriptor | async)">
    {{
    HsLanguageService.getTranslationIgnoreNonExisting(
    "LAYERMANAGER.layerEditor",
    (layerDescriptor | async).type,
    undefined
    )
    }}<!-- TODO: Remove function call from template -->
    {{ "LAYERMANAGER.layerEditor.layerFrom" | translateHs }}
    <span class="text-truncate mw-100 d-block">
      {{
      HsLanguageService.getTranslationIgnoreNonExisting(
      "LAYERMANAGER.layerEditor",
      (layerDescriptor | async).source,
      undefined
      )
      }}<!-- TODO: Remove function call from template -->
    </span>
  </small>
</div>